import { z } from 'zod';
import { apvSelectSchema, apvSelectDefaults } from '../apv-select/schema';

export const apvSelectOneSchema = apvSelectSchema;

export type APVSelectOneFormValues = z.infer<typeof apvSelectOneSchema>;

export const apvSelectOneDefaults = apvSelectDefaults;
